/**
 * 个人中心接口请求封装。
 *
 * 负责将个人资料、企业绑定和微信绑定等页面操作转换为 HTTP 请求；不处理页面状态、提示或业务结果展示。
 * 调用会发起网络请求，并依赖 `@/utils/request` 统一附加认证信息、处理响应与将网络或服务端错误以 Promise 拒绝形式上抛。
 * 微信绑定接口必须使用 `VUE_APP_Dzy`，因为其路由由地质云 API 服务提供，而非系统 API 服务。
 */
import request from '@/utils/request'

export function PerfectInformation(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/PerfectInformation',
        method: 'post',
        data
    })
}

export function GetEntityByID(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Enterprises/GetEntityByID',
        method: 'post',
        params:data
    })
}

//操作日志
export function GetLogListPage(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/GetLogListPage',
        method: 'get',
        params:data
    })
}


export function GetUserinfo(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/GetUserinfo',
        method: 'post',
        params:data
    })
}

//个人账号注销
export function AccountLogout(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/AccountLogout',
        method: 'post',
        params:data
    })
}
//忘记密码
export function ChangePassword(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/ChangePassword',
        method: 'post',
        params:data
    })
}

//申请绑定企业
export function Applyforenterprisebinding(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/Applyforenterprisebinding',
        method: 'post',
        params:data
    })
}


//审核绑定企业
export function ReviewBindingEnterprise(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/ReviewBindingEnterpriseMethod',
        method: 'post',
        params:data
    })
}

//获取申请绑定企业列表
export function GetReviewBindingEnterpriseListPage(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/GetReviewBindingEnterpriseListPage',
        method: 'get',
        params:data
    })
}

//根据用户ID获取最新的申请审核记录
export function GetReviewBindingEnterpriseByUserID(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/GetReviewBindingEnterpriseByUserID',
        method: 'post',
        params:data
    })
}


//上传图片
export function UploadQianming(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/PersonalCenter/UploadQianming',
        method: 'post',
        data,
        contentType:"multipart/form-data"
    })
}

/**
 * 获取指定用户的微信绑定状态。
 *
 * @param {Object} data 查询参数，必须包含非空的 `userId` 字符串。
 * @returns {Promise<Object>} 地质云 API 的响应；成功时响应数据包含绑定状态及微信展示信息。
 * @throws {Error} 请求超时、网络不可用或服务端返回错误时，由统一请求拦截器拒绝 Promise。
 * @sideEffects 向 `VUE_APP_Dzy` 指向的地质云 API 发送 GET 请求。
 */
export function GetWechatBindStatus(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/userwechatauth/bindstatus',
        method: 'get',
        params: data
    })
}

/**
 * 将微信授权结果关联到指定用户。
 *
 * @param {Object} data 请求参数，必须包含非空的 `userId` 与微信授权返回的 `code`。
 * @returns {Promise<Object>} 地质云 API 的绑定结果响应。
 * @throws {Error} 授权码无效、用户不存在、网络异常或服务端返回错误时，由统一请求拦截器拒绝 Promise。
 * @sideEffects 向 `VUE_APP_Dzy` 指向的地质云 API 发送 POST 请求，可能创建或更新微信授权关联。
 */
export function BindWechat(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/userwechatauth/bind',
        method: 'post',
        params: data
    })
}

/**
 * 移除指定用户与微信账号的关联。
 *
 * @param {Object} data 请求参数，必须包含非空的 `userId` 字符串。
 * @returns {Promise<Object>} 地质云 API 的解绑结果响应。
 * @throws {Error} 用户不存在、关联记录处理失败、网络异常或服务端返回错误时，由统一请求拦截器拒绝 Promise。
 * @sideEffects 向 `VUE_APP_Dzy` 指向的地质云 API 发送 POST 请求，可能删除微信授权关联。
 */
export function UnbindWechat(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/userwechatauth/unbind',
        method: 'post',
        params: data
    })
}



// WEBPACK FOOTER //
// ./src/areas/PersonalCenter/api/Center.js